// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__1Q2uV","head":"index_head__NhYx_","head_crumbs":"index_head_crumbs__2ShTT","head_line":"index_head_line__3apwZ"};